import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewActivityQuestionsComponent } from 'src/app/course-management/activity-questions/view-activity-questions/view-activity-questions.component';
import { SwitchDashboardComponent } from 'src/app/course-management/switch-dashboard/switch-dashboard.component';
import { CompleteCurriculum } from 'src/app/courseManagementClasses/complete-curriculum';
import { Curriculum } from 'src/app/courseManagementClasses/curriculum';
import { GlobalClass } from 'src/app/global/global-class';
import { LogoutWarningModalComponent } from 'src/app/logout/logout-warning-modal/logout-warning-modal.component';
import { ActivityPlannerService } from 'src/app/service/activity-planner.service';
import { CurriculumService } from 'src/app/service/curriculum.service';
import { FileServiceService } from 'src/app/service/file-service.service';
import { LogoutService } from 'src/app/service/loginLogout/logout.service';
import { TeacherService } from 'src/app/service/teacher.service';
import { OfficesService } from 'src/app/services/office/offices.service';
import { SharedDataService } from 'src/app/services/sharedData.service';
import { environment } from 'src/environments/environment';
import { ViewActivityPlannerForTeacherModalComponent } from '../view-activity-planner-for-teacher-modal/view-activity-planner-for-teacher-modal.component';


interface curr {
  curriculumName: string;
  curriculumId : string;
  children?: curr[];
}

const TREE_DATA: any[] = [
 {
    name: 'Vegetables',
    children: [{name: 'Green',
                children: [
                            {name: 'Broccoli'},
                            {name: 'Brussels sprouts'},
                          ]
              }
    ]
  },
];

 const currList = [
  {
     name : '',
     id : '',
     children: [{name : '',
                 id : '',
                 children: [{name: '',
                              id : ''}]
               }]
  }];
 

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  curriculumId : string,
  level: number;
}


@Component({
  selector: 'app-curriculum-of-subject-page',
  templateUrl: './curriculum-of-subject-page.component.html',
  styleUrls: ['./curriculum-of-subject-page.component.scss']
})
export class CurriculumOfSubjectPageComponent implements OnInit {

  private _transformer = (node: curr, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.curriculumName,
      curriculumId : node.curriculumId,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  
  readMore = false;
  currentRole="TEACHER";
  showSpinner : boolean = true;
  userId!: string;
  userName : any;
  loggedUser : any;
  loggedInUser : any;
  theme: string = '';
  subjectId!: string;
  public screenWidth: any;
  public screenHeight: any;
  curriculum : CompleteCurriculum = new CompleteCurriculum();
  mainCurriculums : Curriculum[] = [];
  subCurriculums : Curriculum[] = [];
  subCurriculums2 : Curriculum[] = [];
  xyz: any;
  abc: any;
  apafDontExist = false;
  apafExist = false;
  centered = false;
  disabled = false;
  unbounded = false;
  asDontExist = false;
  showActivities : boolean = true;
  apDontExist = false;
  assignments : any[] =[ {  activityPlannerId : '', 
                          activityPlannerName : '',
                          activityPlannerDescription : '',
                          activityPlannerOrder : '',
                          activityPlannerStatus : '',
                          fkSubjectId : '',
                          activityPlannerImage : '' ,
                          safeUrl : '',
                          type : '',
                          collapsedState : '',
                          collapsedState2 : '',
                          readMore : '',

                          activityVideoLinkList : [{
                                                      actVideoLinkId: "",
                                                      actVideoLinkName: "",
                                                      actVideoLink: "",
                                                      actVideoLinkDescription: "",
                                                      fkActivityPlannerId: "",
                                                      actVideoLinkStatus: "",
                                                      urlSafe: ""
                                                    }]
                                                            }];
selected = '1';
selected2 = '2';

curriculumExists = false;

officeObject : any = {
  activeStatus: '',
  backgroundColor: '',
  id:'',
  logo: '',
  oa_ParentMentor:'',
  oa_SubAdmin: '',
  oa_SkillReport: '',
  oa_ParentFeedback: '',
  oa_Assignment: '',
  officeLocation: '',
  officeName: '',
  themeColour: ''
}

  radius!: number;
  color!: string;
  safeImageUrl: any;
  unsafeImageUrl: any
  url: string = "https://www.youtube.com/embed/zpOULjyy-n8?rel=0";
  urlSafe!: SafeResourceUrl;
  mainCurriculumIds : any[] =[];
  mainCurrState : boolean = true;
  mainCurrState2 : boolean = false;
  infoState : boolean = false;
  mainCurrState3 : boolean = false;
  prevParentId : string = '';
  prevParentId2 : string = '';
  curriculumObject : Curriculum = new Curriculum();
  activityPlanners : any[] =[ {  activityPlannerId : '', 
  activityPlannerName : '',
  activityPlannerDescription : '',
  activityPlannerOrder : '',
  activityPlannerStatus : '',
  fkSubjectId : '',
  activityPlannerImage : '' ,
  safeUrl : '',
  collapsedState : '',
  collapsedState2 : '',
  type : '',
  readMore : '',
  activityVideoLinkList : [{
                              actVideoLinkId: "",
                              actVideoLinkName: "",
                              actVideoLink: "",
                              actVideoLinkDescription: "",
                              fkActivityPlannerId: "",
                              actVideoLinkStatus: "",
                              urlSafe: ""
                            }]
                                    } ];

                                    activityPlanners2 : any[] =[ {  activityPlannerId : '', 
                                    activityPlannerName : '',
                                    activityPlannerDescription : '',
                                    activityPlannerOrder : '',
                                    activityPlannerStatus : '',
                                    fkSubjectId : '',
                                    activityPlannerImage : '' ,
                                    safeUrl : '',
                                    collapsedState : '',
                                    collapsedState2 : '',
                                    type : '',
                                    readMore : '',
                                    
                                    activityVideoLinkList : [{
                                                                actVideoLinkId: "",
                                                                actVideoLinkName: "",
                                                                actVideoLink: "",
                                                                actVideoLinkDescription: "",
                                                                fkActivityPlannerId: "",
                                                                actVideoLinkStatus: "",
                                                                urlSafe: ""
                                                              }]
                                                                      } ];

                                    currm : curr[] = [
                                      {
                                        curriculumName : '',
                                        curriculumId : '',
                                         children: [{curriculumName : '',
                                                     curriculumId : '',
                                                     children: [{curriculumName: '',
                                                                 curriculumId : ''}]
                                                   }]
                                      }];
  config = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class: 'modal-md'
  };


 hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
 

  level0exists : boolean = true;
  level1exists : boolean = true;
  level2exists : boolean = true;
  navbarTitle: any;
  officeId: any;

  constructor(private sharedDataService: SharedDataService, 
              private imageService : FileServiceService,
              private sanitizer : DomSanitizer,
              private officeService : OfficesService ,
              private ngbModalService: NgbModal,
              public router: Router,
              public route : ActivatedRoute,
              private activityPlannerService : ActivityPlannerService,
              private logoutService : LogoutService,
              private teacherService : TeacherService,
              private curriculumService : CurriculumService ) { }

  ngOnInit(): void {

    this.navbarTitle = GlobalClass.navbarTitle;

    this.dataSource.data = this.currm;

    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;

    this.subjectId = this.route.snapshot.params['subjectId'];

    this.loggedUser = localStorage.getItem('loggedUser');
    this.loggedInUser = JSON.parse(this.loggedUser);
    this.userName = this.loggedInUser?.firstName + ' ' + this.loggedInUser?.lastName;
    this.theme = this.sharedDataService.getCardOfficeTheme();
    this.userId = this.loggedInUser.userId;
    this.officeId = this.loggedInUser.offices[0].id;

      // authorized
      this.officeService.getOfficeByIdForTeacher(environment.apiUrl + "teacher/getOfficeByIdForTeacher/" + this.officeId).then(
        data=>{        
          this.officeObject = data;
        });
  
    this.getCurriculum();
  }

   // authorized
  getDetails(currId : any){
    this.showSpinner = true;
    this.apDontExist = false;
    this.asDontExist = false;
   
    this.curriculumService.getCurrByIdForTeacher(environment.apiUrl + "curriculum/getCurriculumByIdForTeacher/" + currId).then(
      data=>{
        this.curriculumObject = data;
        this.infoState = true;
        this.curriculumExists === true;
this.getactivityPlanners(currId);
this.getAssignmentListByCurId(currId);

      });
  }

  valueChange(value : any){
    this.showSpinner = true;
    if(this.showActivities === true){
     this.showActivities = false;
     setTimeout(()=>{                          
       this.showSpinner = false;
   }, 1000);
    }else  if(this.showActivities === false){
     this.showActivities = true;
     setTimeout(()=>{                          
       this.showSpinner = false;
   }, 1000);
    }
  }

  // authorized
  getAssignmentListByCurId(curId : string){
    this.activityPlannerService.getAssignmentListByCurIdForTeacher(environment.apiUrl + "activityPlanner/getAssignmentListByCurIdForTeacher/" + curId).then(
      data=>{
               this.assignments = data;   
               
 
 if(this.assignments === undefined || this.assignments.length === 0){
 
   this.asDontExist = true;
 
   setTimeout(()=>{                         
     this.showSpinner = false;
 }, 1000);
 
 
 }
               this.assignments.forEach( (value) => {
                           
                value.readMore = false;

                 this.imageService.getActivityPlannerImage( value.activityPlannerImage ).subscribe(
                   data=>{
                     this.xyz = data;
                     this.abc = URL.createObjectURL(data);
                     this.xyz = this.sanitizer.bypassSecurityTrustUrl( this.abc);
 
                     value.safeUrl = this.xyz;
                     value.collapsedState = false;
                     value.collapsedState2 = false;
                   });
       
               }); 
 
               
      });
 
    }

    collapseActivityCardContent(activityPlannerId : string){

      this.activityPlanners.forEach((value)=>{
  
        if(value.activityPlannerId === activityPlannerId){
  
          if(value.collapsedState === true){
            value.collapsedState = false
          } else if(value.collapsedState === false){
            value.collapsedState = true
          }
  
        }
      }); 
  
    }
  
    collapseActivityCardContent2(activityPlannerId : string){
  
    this.assignments.forEach((value)=>{
  
      if(value.activityPlannerId === activityPlannerId){
  
        if(value.collapsedState === true){
          value.collapsedState = false;
        } else if(value.collapsedState === false){
          value.collapsedState = true;
        }
  
      }
    });
  }

  // authorized
  getactivityPlanners(currId : any){
    this.activityPlannerService.getActivityPlannerListByCurIdForTeacher(environment.apiUrl + "activityPlanner/getActivityPlannerListByCurIdForTeacher/" + currId).then(
      data=>{
        this.apafDontExist = false;
        this.apafExist = false;
        this.activityPlanners = [];
        this.activityPlanners2 = [];
        this.activityPlanners.pop();

        for(var index in data){
          this.activityPlanners.push( {  'activityPlannerId' : data[index].activityPlannerId, 
                                              'activityPlannerName' : data[index].activityPlannerName,
                                              'activityPlannerDescription' : data[index].activityPlannerDescription,
                                              'activityPlannerOrder' : data[index].activityPlannerOrder,
                                              'activityPlannerStatus' : data[index].activityPlannerStatus,
                                              'fkSubjectId' : data[index].fkSubjectId,
                                              'activityPlannerImage' : data[index].activityPlannerImage ,
                                              'safeUrl' : this.safeImageUrl ,
                                              'collapsedState' : false,
                                              'collapsedState2' : false,
                                              'type' : data[index].type,
                                              'activityVideoLinkList' : data[index].activityVideoLinkList,
                                              'readMore' : false
                                                    });
}

if(this.activityPlanners === undefined || this.activityPlanners.length === 0){

this.apDontExist = true;

  setTimeout(()=>{                          
    this.showSpinner = false;
}, 1000);


}

this.activityPlanners.forEach( (value) => {
          
  this.imageService.getActivityPlannerImage( value.activityPlannerImage ).subscribe(
    data=>{
      this.unsafeImageUrl = URL.createObjectURL(data);
      this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl( this.unsafeImageUrl);

      value.safeUrl = this.safeImageUrl;
     });


     value.activityVideoLinkList.forEach((val : any)=>{
    this.url =  val.actVideoLink;
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    val.urlSafe = this.urlSafe

    setTimeout(()=>{                           //timer
      this.showSpinner = false;
 }, 1000);

  });
   });

   let count = 0;
   this.activityPlanners.forEach((value2)=>{
    count++;  
     if(value2.type === "activityPlanner"){
      this.activityPlanners2.push(value2);
    }
  })

  if(count === this.activityPlanners.length){
    if(this.activityPlanners2.length === 0 || this.activityPlanners2 === undefined){
      this.apDontExist = true;
    }
  }
   
 });

  }

  // authorized
  getCurriculum(){
    this.curriculumService.getSortedCurrListBySubIdForTeacher(environment.apiUrl + "curriculum/getSortedCurrListBySubIdForTeacher/" + this.subjectId).then(
      data=>{
this.currm= data;
this.dataSource.data = this.currm;
setTimeout(()=>{                           //timer
  this.showSpinner = false;
}, 1000);
            });

            if(this.currm === undefined || this.currm.length === 0){
              setTimeout(()=>{                           //timer
                this.showSpinner = false;
           }, 1000);
            }
  }

  show(){
    this.showSpinner = true;
    if(this.showActivities === true){
     this.showActivities = false;
     setTimeout(()=>{                           //timer
       this.showSpinner = false;
   }, 1000);
    }else  if(this.showActivities === false){
     this.showActivities = true;
     setTimeout(()=>{                           //timer
       this.showSpinner = false;
   }, 1000);
    }
  }

goToHomePage(){
  this.router.navigate(['/dashboard/teacher']);
}


get backgroundStyle(){
  let globalClass : GlobalClass = new GlobalClass() ;
  return globalClass.backgroundStyle(this.loggedInUser.offices[0].theme);
}

switchDashboard(){
    this.config.class = 'modal-md';
    const modalRef = this.ngbModalService.open( SwitchDashboardComponent,
      {
        size : 'sm',
        scrollable: true,
        windowClass: 'app-modal-window',
        keyboard: false
      });
    let data = {
      userId : this.userId,
      currentRole : this.currentRole
    }

    modalRef.componentInstance.fromParent = data;
      modalRef.result.then((result) => {
      }, (reason) => {
      });

    modalRef.componentInstance.passEntry.subscribe((receivedEntry : string) => {
    });    
  }

  goToAccountPage(){
    this.router.navigate(['user-account',this.userId])
  }
 
  // AUTHORIZED
  viewActivityQuestionsModal(activityPlannerId : string){
    this.config.class = 'modal-md';
    const modalRef = this.ngbModalService.open(ViewActivityQuestionsComponent,
      {
        size : 'lg',
        scrollable: true,
        windowClass: 'app-modal-window',
      keyboard: false
      });

    let data = {
      activityPlannerId: activityPlannerId ,
      access : 'TEACHER-VIEW-ONLY'
      }

    modalRef.componentInstance.fromParent = data;
      modalRef.result.then((result) => {
      }, (reason) => {
      });

  modalRef.componentInstance.passEntry.subscribe((receivedEntry : any) => {
  }); 
  }

  getColor(){
    this.sharedDataService.setfooterColor(this.loggedInUser.offices[0].theme);
    return this.loggedInUser.offices[0].theme + '!important';
  }

  logOut(): void {
    this.config.class = 'modal-md';
    const modalRef = this.ngbModalService.open( LogoutWarningModalComponent,
      {
        size : 'md',
        scrollable: true,
        windowClass: 'app-modal-window',
        keyboard: false
      });
    let data = {
     email : this.loggedInUser.email 
    }
  
    modalRef.componentInstance.fromParent = data;
      modalRef.result.then((result) => {
      }, (reason) => {
      });
  
    modalRef.componentInstance.passEntry.subscribe((receivedEntry : string) => {
    });  
  }
  
  goBack() {
    this.router.navigate(['/dashboard/user']).then();
  }

  reloadPage() {
    window.location.reload();
  }
}
